import { HostingElement } from '@anm/api/modules/hosting';
import { Reducer } from 'react';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { HostedVideoActions } from '..';
import { deleteVideoAsync } from '../actions';

import { initialHostedVideoState } from './index';

const deleteVideoReducer: Reducer<
  typeof initialHostedVideoState,
  HostedVideoActions
> = (state = initialHostedVideoState, action) => {
  switch (action.type) {
    case getType(deleteVideoAsync.request): {
      const { payload: id } = action;
      return {
        ...state,
        deleteVideo: {
          ...state.deleteVideo,
          isPending: true,
          isError: false,
          params: { id }
        }
      };
    }
    case getType(deleteVideoAsync.success): {
      const { id } = state.deleteVideo.params!;
      const oldList = state.list || [];
      const newList = oldList.filter(
        (el: HostingElement) => el!.uploadId !== id
      );
      return {
        ...state,
        list: newList,
        deleteVideo: {
          ...state.deleteVideo,
          isPending: false,
          isError: false,
          error: null
        }
      };
    }
    case getType(deleteVideoAsync.failure): {
      const error = action.payload;
      return {
        ...state,
        deleteVideo: {
          ...state.deleteVideo,
          error,
          isPending: false,
          isError: true
        }
      };
    }
    default:
      return state;
  }
};

export default deleteVideoReducer;
